export default function getCannyOrigin(company) {
  if (!company.primaryDomain || (__DEV__ && !__TEST__)) {
    return 'https://' + company.subdomain + '.canny.io';
  }

  return 'https://' + company.primaryDomain;
}
